import { validate as validateEmail } from 'email-validator';
import PasswordValidator from 'password-validator';

export const passwordStrength = (password: string) => {
	const schema = new PasswordValidator();
	schema.min(8);
	schema.uppercase(1);
	schema.symbols(1);
	schema.digits(1);

	return schema.validate(password, { details: true });
};

export const isValidEmail = (email: string) => {
	return validateEmail(email);
};
